import { urlEmpresa, urlFiles, urlFlujoArt, urlMail } from '@/helpers';
import { useAuthHeaders } from '@/composables/useAuthHeaders';
import { httpInstance } from '@/clients/http.request';
import { sendFallbackEmail } from '@/composables/useFallbackEmail';

export const postFile = async (_, formData) => {
   const { getAuthHeaders } = useAuthHeaders();
   const { ok, config, message } = getAuthHeaders();
   if (!ok) {
      return { ok: false, message };
   }

   try {
      const response = await httpInstance.post(urlFiles, formData, true);
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getFiles = async (_, data) => {
   try {
      const response = await httpInstance.post(`${urlFiles}/getFiles`, {
         id_poliza: data.id_poliza,
         cotizaciones: data.cotizacion,
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getLocalidadPoliza = async (_, id_localidad) => {
   try {
      const { data } = await httpInstance.get(`${urlFlujoArt}/getLocalidad`, {
         id_localidad,
      });
      return data.localidad;
   } catch (error) {
      throw error;
   }
};

export const updateCompaniaAnterior = async (_, data) => {
   try {
      const response = await httpInstance.put(
         `${urlFlujoArt}/updateCompaniaAnterior`,
         data,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const cotizaciones = async (_, id_poliza) => {
   try {
      const response = await httpInstance.get(`${urlFlujoArt}/cotizaciones`, {
         id_poliza,
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getCompaniaSeguimiento = async (_, id_seguimiento) => {
   try {
      const response = await httpInstance.get(
         `${urlFlujoArt}/companiaSeguimiento`,
         {
            id_seguimiento,
         },
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const notaDesignacion = async (_, payload) => {
   const { id_poliza, id_cliente, id_empresa, id_seccion, files } = payload;

   const formData = new FormData();

   if (files && Array.isArray(files)) {
      files.forEach((file) => {
         formData.append('files', file);
      });
   }

   formData.append('id_poliza', id_poliza);
   formData.append('id_cliente', id_cliente);
   formData.append('id_empresa', id_empresa);
   formData.append('id_seccion', id_seccion);

   try {
      const response = await httpInstance.post(
         `${urlFlujoArt}/nota-designacion`,
         formData,
         true,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const sendEmailArtBSA = async ({ dispatch, rootState }, data) => {
   try {
      const response = await httpInstance.post(
         `${urlMail}/sendEmailCaucion`,
         data,
      );
      return response.data;
   } catch (error) {
      try {
         await sendFallbackEmail({
            id_poliza: rootState?.poliza?.poliza?.id_poliza,
         });
      } catch (fallbackError) {
         console.error('Error al enviar fallback email:', fallbackError);
      }
      throw error;
   }
};

export const getEmpresaCodes = async (
   _,
   { id_empresa, id_compania, id_seccion },
) => {
   try {
      const response = await httpInstance.get(
         `${urlEmpresa}/codes/${id_empresa}/${id_compania}/${id_seccion}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresaIcon = async (_, { id_empresa }) => {
   try {
      const response = await httpInstance.getFileEmail(
         `${urlEmpresa}/icon`,
         { id: id_empresa },
         { responseType: 'arraybuffer' },
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};
